import { useEffect } from 'react';

const SEO = ({ title, description, keywords, image, url }) => {
  useEffect(() => {
    document.title = title ? `${title} | Nathnagri Temples` : 'Nathnagri Temples of Bareilly - A Spiritual Journey';

    const setMetaTag = (name, content, attribute = 'name') => {
      if (!content) return;
      let tag = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    setMetaTag('description', description || 'Discover the divine spiritual history of the Nathnagri Temples of Bareilly. Explore deep culture, traditions, and divine pilgrimage.');
    setMetaTag('keywords', keywords || 'temples, bareilly, nathnagri, shiva, alakhnath, trivatinath, spiritual, pilgrimage, hinduism');
    
    // OpenGraph / Facebook
    setMetaTag('og:title', title || 'Nathnagri Temples of Bareilly', 'property');
    setMetaTag('og:description', description || 'Discover the divine spiritual history of the Nathnagri Temples.', 'property');
    if (image) setMetaTag('og:image', image, 'property');
    setMetaTag('og:url', url || window.location.href, 'property');
    setMetaTag('og:type', 'website', 'property');
    
    // Twitter
    setMetaTag('twitter:card', 'summary_large_image', 'name');
    setMetaTag('twitter:title', title || 'Nathnagri Temples of Bareilly', 'name');
    setMetaTag('twitter:description', description || 'Discover the divine spiritual history of the Nathnagri Temples.', 'name');
    if (image) setMetaTag('twitter:image', image, 'name');

  }, [title, description, keywords, image, url]);

  return null; 
};

export default SEO;
